import Swiper from 'swiper'
import { Pagination, Navigation } from 'swiper/modules'

import 'swiper/css'
import 'swiper/css/pagination'
import 'swiper/css/navigation'

window.addEventListener('load', function () {
  const mainElement = document.querySelector('body')
  if (mainElement && mainElement.classList.contains('lp_region')) {
    const mySwiper = new Swiper('.sec08_slider', {
      slidesPerView: 1.77,
      spaceBetween: 8,
      centeredSlides: true,
      loop: true,
      modules: [Pagination, Navigation],
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
      },
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      breakpoints: {
        768: {
          slidesPerView: 3.6,
          spaceBetween: 12,
        },
      },
      on: {
        slideChange: function () {
          const realIndex = this.realIndex

          // .content 切替
          document.querySelectorAll('.content').forEach((el) => {
            el.classList.remove('active')
          })

          const targetContent = document.querySelector(`.content[data-index="${realIndex}"]`)
          if (targetContent) {
            targetContent.classList.add('active')
          }
        }
      }
    })

    // スライドをクリックでセンターに移動
    const slides = document.querySelectorAll('.sec08_slider .swiper-slide')
    slides.forEach((slide) => {
      slide.addEventListener('click', () => {
        const realIndex = parseInt(slide.getAttribute('data-swiper-slide-index'), 10)
        mySwiper.slideToLoop(realIndex)
      })
    })
  }
})
